import { SOCIAL_URLS } from "common/constants/marketing";
import Footer from "lib/components/footers/Footer";
import {
  aboutPath,
  careersPath,
  contactFormPath,
  contactPath,
  pressPath,
  privacyPolicyPath,
  termsAndConditionsPath,
} from "lib/routeHelpers";
import type { ReactNode } from "react";
import React from "react";
import Link from "ui/components/Link";
import cx from "ui/cx";
import styles from "./LandingPageFooter.module.scss";

interface FooterLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  children: ReactNode;
}

const FooterLink = ({ children, href, ...props }: FooterLinkProps) => {
  return (
    <Link
      href={href}
      {...props}
      onClick={
        // This is a bit of a kludge because it works around the type safety of the event handler.
        props.onClick
          ? (e: React.MouseEvent<HTMLAnchorElement> | null) => props.onClick?.(e as React.MouseEvent<HTMLAnchorElement>)
          : undefined
      }
      className="link"
    >
      {children}
    </Link>
  );
};

interface LandingPageFooterProps {
  ctaText?: string;
  ctaHref?: string;
}

export default function LandingPageFooter({
  ctaText = "Get in Touch",
  ctaHref = contactFormPath,
}: LandingPageFooterProps) {
  const copyrightText = `© ${new Date().getFullYear()} Higharc Inc.`;
  const dotSeperator = "\u00B7";

  return (
    <Footer>
      <div className="top" />
      <div className={cx({ styles, wrapper: true }, "grid-container")}>
        <div className="left">
          <div className="copyright-desktop">{copyrightText}</div>
          <div className="dot-seperator">{dotSeperator}</div>
          <FooterLink href={termsAndConditionsPath}>Terms</FooterLink>
          <div className="dot-seperator">{dotSeperator}</div>
          <FooterLink href={privacyPolicyPath}>Privacy</FooterLink>
        </div>
        <div className="right">
          <FooterLink href={ctaHref}>{ctaText}</FooterLink>
          <FooterLink href={aboutPath}>About</FooterLink>
          <FooterLink href={careersPath}>Careers</FooterLink>
          <FooterLink href={contactPath}>Contact</FooterLink>
          <FooterLink href={pressPath}>Press</FooterLink>
          <div className="spacer">
            <span className="divider" />
          </div>
          <div className="copyright-mobile">{copyrightText}</div>
          <div className="social">
            <FooterLink href={SOCIAL_URLS.twitter} target="_blank" rel="noreferrer">
              <div className="icon twitter" />
            </FooterLink>
            <FooterLink href={SOCIAL_URLS.facebook} target="_blank" rel="noreferrer">
              <div className="icon facebook" />
            </FooterLink>
            <FooterLink href={SOCIAL_URLS.instagram} target="_blank" rel="noreferrer">
              <div className="icon instagram" />
            </FooterLink>
            <FooterLink href={SOCIAL_URLS.linkedin} target="_blank" rel="noreferrer">
              <div className="icon linkedin" />
            </FooterLink>
            <FooterLink href="/demo/ibs-2023-start">
              <div className="icon ibs" />
            </FooterLink>
          </div>
        </div>
      </div>
    </Footer>
  );
}
